/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpgatesAddonInstallRequest
 */
export interface UpgatesAddonInstallRequest {
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstallRequest
     */
    token: string;
    /**
     * 
     * @type {number}
     * @memberof UpgatesAddonInstallRequest
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstallRequest
     */
    apiUser: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstallRequest
     */
    apiKey: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstallRequest
     */
    apiUrl: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstallRequest
     */
    currentAdminLanguage?: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstallRequest
     */
    time: string;
    /**
     * 
     * @type {string}
     * @memberof UpgatesAddonInstallRequest
     */
    signatureV2: string;
}

/**
 * Check if a given object implements the UpgatesAddonInstallRequest interface.
 */
export function instanceOfUpgatesAddonInstallRequest(value: object): value is UpgatesAddonInstallRequest {
    if (!('token' in value) || value['token'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('apiUser' in value) || value['apiUser'] === undefined) return false;
    if (!('apiKey' in value) || value['apiKey'] === undefined) return false;
    if (!('apiUrl' in value) || value['apiUrl'] === undefined) return false;
    if (!('time' in value) || value['time'] === undefined) return false;
    if ((!('signatureV2' in (value as Record<string, any>)) && !('signature_v2' in (value as Record<string, any>))) || ((value as Record<string, any>)['signatureV2'] === undefined && (value as Record<string, any>)['signature_v2'] === undefined)) return false;
    return true;
}

export function UpgatesAddonInstallRequestFromJSON(json: any): UpgatesAddonInstallRequest {
    return UpgatesAddonInstallRequestFromJSONTyped(json, false);
}

export function UpgatesAddonInstallRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpgatesAddonInstallRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'],
        'version': json['version'],
        'apiUser': json['apiUser'],
        'apiKey': json['apiKey'],
        'apiUrl': json['apiUrl'],
        'currentAdminLanguage': json['current_admin_language'] == null ? undefined : json['current_admin_language'],
        'time': json['time'],
        'signatureV2': json['signature_v2'],
    };
}

export function UpgatesAddonInstallRequestToJSON(json: any): UpgatesAddonInstallRequest {
    return UpgatesAddonInstallRequestToJSONTyped(json, false);
}

export function UpgatesAddonInstallRequestToJSONTyped(value?: UpgatesAddonInstallRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': value['token'],
        'version': value['version'],
        'apiUser': value['apiUser'],
        'apiKey': value['apiKey'],
        'apiUrl': value['apiUrl'],
        'current_admin_language': value['currentAdminLanguage'],
        'time': value['time'],
        'signature_v2': value['signatureV2'],
    };
}

